export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-6 text-center">
            关于豆花
          </h2>
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-8">
            <div className="flex flex-col gap-4">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed font-body">
                豆花视频是一个免费影视资源聚合平台，致力于为影迷提供便捷的在线观影服务。我们汇集了西瓜视频、芒果视频、丝瓜视频等多个平台的优质内容，涵盖电影大全、电视剧全集、热门综艺、动漫番剧等丰富品类。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed font-body">
                平台始终坚持免费在线观看的理念，无需注册、无需付费、无需下载，打开即可享受高清流畅的观影体验。内容每日同步更新，确保用户第一时间看到最新剧集。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed font-body">
                豆花视频的名字源自我们对影视内容"细腻丰富、回味悠长"的追求——就像一碗温润的豆花，给人最纯粹的享受。未来我们将持续拓展内容来源，优化播放体验，让更多观众享受免费高清影视的乐趣。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              {['免费观影', '高清流畅', '每日更新', '资源丰富', '无需注册'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-label font-medium"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}